import { render, staticRenderFns } from "./CreateEducationalPost.vue?vue&type=template&id=477a576c&scoped=true&"
import script from "./CreateEducationalPost.vue?vue&type=script&lang=js&"
export * from "./CreateEducationalPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a576c",
  null
  
)

export default component.exports